import { createActionConst } from '../../../utils/action.utils';

const PAYMENT_METHOD_NAMESPACE = 'PAYMENT_METHOD';

export const STORE_PAYMENT_METHOD = createActionConst(PAYMENT_METHOD_NAMESPACE, 'STORE_PAYMENT_METHOD');
export const CLEAR_PAYMENT_METHOD = createActionConst(PAYMENT_METHOD_NAMESPACE, 'CLEAR_PAYMENT_METHOD');
